import r from "react";
const l = (e) => r.Children.toArray(e).filter(
  (t) => r.isValidElement(t)
);
export {
  l as getValidChildren
};
